import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
} from "react";

import styled from "styled-components";
import { UiModal } from "./PluginGroup/ModalUi";
import { ModalUiEnv } from "./PluginGroup/UiMadalEnv";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import { IconName, IconNames } from "@blueprintjs/icons";
import { Button, Collapse, Icon, Overlay, Tooltip } from "@blueprintjs/core";
import { Help, ListItem, Name, Version } from "./JSDependencies";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../reducers";
import {
  deleteUi,
  restartUiApi,
} from "../../../components/designSystems/appsmith/help/FileManagerApi";
import { ReduxActionTypes } from "../../../constants/ReduxActionConstants";
import { deleteDatasource } from "../../../actions/datasourceActions";
import { Colors } from "../../../constants/Colors";
import { ReactComponent as CopyIcon } from "../../../assets/icons/control/copy.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/control/delete.svg";
import { ReactComponent as Update } from "../../../assets/icons/help/update.svg";
import { AppToaster } from "../../../components/editorComponents/ToastComponent";
import { ToastType } from "react-toastify";
import { ReactComponent as Add } from "../../../assets/images/work_space/add.svg";
import { ReactComponent as Close } from "../../../assets/images/work_space/close.svg";
import { ReactComponent as Open } from "../../../assets/images/work_space/open.svg";
import { ModalDelete } from "../../../components/designSystems/component/ModalDelete";
import { createIdLoading, LoadingItem } from "../DoclLayoutSettings";

export const Info = styled.div`
  // width: 60px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  display: none;
  span {
    height: 100%;
    display: flex;
    align-items: center;
  }
  svg {
    width: 14px;
    height: 14px;
    fill: #6c767e;
    margin-right: 2px;
    margin-left: 2px;
    path {
      fill: #6c767e;
    }
  }
`;
export const WrapperItemCollapse = styled.div`
  .bp3-collapse-body {
    border-left: 1px solid #afb4b8;
    margin-left: 8px;
  }
  // .bp3-collapse-body:hover{
  //   background: #e8e8e8;
  // }
  // .bp3-collapse {
  //   background: rgba(255, 255, 255, 0.7);
  // }
  .active {
    background: #e8e8e8;
  }
`;
export const WrapperCollapse = styled.div`
  width: 100%;
  height: 22px;
  cursor: pointer;
  display: flex;
  padding: 3px 2px 2px 3px;
  justify-content: space-between;
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
  font-family: "Roboto";
  color: #495870;
  &:hover {
    background: #e8e8e8;
  }
  .icon_open_close {
    width: 10px;
  }
  .bp3-collapse-body {
    border-left: 1px solid #6c767e;
    margin-left: 8px;
  }
`;
export const AddNodeRed = styled.div`
    width: 16px;
    margin-right:6px;
    cursor: pointer;
    height: 100%;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #DFDFDF;
      &:hover{
        background: #F3F3F3;
        color: #DFDFDF;
      }
}`;

export const UiEditorCollapse = forwardRef((props: any, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const openModal = () => {
    childRef?.current?.openModal();
  };

  useImperativeHandle(ref, () => ({
    close() {
      setIsOpen(false);
    },
  }));

  const dispatch = useDispatch();
  const currentApplication = useSelector(
    (state: AppState) => state.ui.applications.currentApplication,
  );
  const currentOrg = useSelector(
    (state: AppState) => state.ui.applications.currentApplication?.orgId,
  );
  const keycloakAccessToken = useSelector(
    (state: AppState) => state.ui.users.currentUser?.keycloakAccessToken,
  );
  const icon = isOpen ? <Open></Open> : <Close></Close>;

  const datasourcesList: any = useSelector(
    (state: AppState) => state.entities.datasources.list,
  );
  const filterDataSource = datasourcesList.filter((item: any) => {
    if (item.id && item.type == "ui") {
      return true;
    }
  });

  const openUI = useCallback((item: any) => {
    dispatch({
      type: ReduxActionTypes.SET_LAYOUT_ITEM,
      payload: {
        id: "nodeRedId",
        title: item.name,
        component: "nodeRed",
        props: "https://" + item.datasourceConfiguration.url + "/home/edit/",
      },
    });
  }, []);

  const deleteUI = useCallback(
    async (item: any) => {
      try {
        await deleteUi({
          orgId: item.organizationId,
          type: "ui",
          name: item.name,
        });

        dispatch({ type: ReduxActionTypes.FETCH_DATASOURCES_INIT });
        const deleteId = JSON.stringify({
          id: item.name,
          type: "nodeRed",
          props: "https://" + item.datasourceConfiguration.url + "/home/edit/",
        });
        dispatch({
          type: ReduxActionTypes.REMOVE_LAYOUT_ITEM,
          payload: {
            id: deleteId,
            title: item.name,
            component: "nodeRed",
            props:
              "https://" + item.datasourceConfiguration.url + "/home/edit/",
          },
        });
      } catch (e) {}
    },
    [datasourcesList, keycloakAccessToken],
  );
  const restartUiServise = useCallback(
    async (item: any) => {
      try {
        const { data } = await restartUiApi(
          {
            name: item.name,
            orgId: currentOrg,
          },
          keycloakAccessToken || "",
        );
        if (data.data.error) {
          AppToaster.show({
            message: `${data.data.message}`,
            type: ToastType.ERROR,
          });
        }
        dispatch({ type: ReduxActionTypes.FETCH_DATASOURCES_INIT });
        dispatch({
          type: ReduxActionTypes.UPDATE_LAYOUT_ITEM,
          payload: {
            id: JSON.stringify({
              id: item.name,
              type: "nodeRed",
              props:
                "https://" + item.datasourceConfiguration.url + "/home/edit/",
            }),
            content: (
              <LoadingItem
                url={
                  "https://" + item.datasourceConfiguration.url + "/home/edit/"
                }
                type={"Loading"}
                title={item.name}
                id={createIdLoading({
                  id: item.name,
                  type: "Loading",
                  props:
                    "https://" +
                    item.datasourceConfiguration.url +
                    "/home/edit/",
                  subtype: "UI",
                })}
              />
            ),
            title: item.name,
            group: "allowWindow",
            closable: true,
          },
        });
      } catch (e) {}
    },
    [datasourcesList, keycloakAccessToken],
  );
  const childRef = useRef<{ openModal: any; setValue: any }>();
  const envUiRef = useRef<any>({});

  const refModalsDelete = useRef<any>({});
  const openModalDelete = useCallback(index => {
    if (refModalsDelete) {
      refModalsDelete.current[index].openModal();
    }
  }, []);
  const openModalEnv = useCallback(index => {
    if (envUiRef) {
      envUiRef.current[index].openModal();
    }
  }, []);
  const handleCollapse = useCallback(async () => {
    dispatch({ type: ReduxActionTypes.FETCH_DATASOURCES_INIT });
    setIsOpen(prevState => !prevState);
  }, []);
  return (
    <WrapperItemCollapse>
      <WrapperCollapse className={`${isOpen && "active"}`}>
        <div
          onClick={handleCollapse}
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className="icon_open_close">{icon}</div>
          <span style={{ paddingLeft: "4px" }}>Ui Editor</span>
        </div>
        <AddNodeRed onClick={openModal}>
          <Add></Add>
        </AddNodeRed>
      </WrapperCollapse>
      <Collapse isOpen={isOpen}>
        {filterDataSource?.map((item: any, index: number) => {
          return (
            <ListItem key={item.name}>
              <Name onClick={() => openUI(item)}>
                <span className="dots">{item.name}</span>
              </Name>
              <Info className="info_collapse">
                <Update onClick={() => restartUiServise(item)}></Update>
                <Help
                  icon="help"
                  iconSize={12}
                  color={Colors.DOVE_GRAY}
                  onClick={() => openModalEnv(index)}
                />
                <ModalUiEnv
                  item={item}
                  ref={element => (envUiRef.current[index] = element)}
                />
                <DeleteIcon onClick={() => openModalDelete(index)}></DeleteIcon>
                <ModalDelete
                  ref={element => (refModalsDelete.current[index] = element)}
                  name={`UI  ${item.name}`}
                  item={item}
                  remove={deleteUI}
                />
                <span
                  onClick={() => {
                    navigator &&
                      navigator.clipboard.writeText(
                        item.datasourceConfiguration.url,
                      );
                    AppToaster.show({ type: "success", message: "Copied Url" });
                  }}
                >
                  <CopyIcon></CopyIcon>
                </span>
              </Info>
            </ListItem>
          );
        })}
      </Collapse>
      <UiModal ref={childRef} />
    </WrapperItemCollapse>
  );
});
UiEditorCollapse.displayName = "UiEditorCollapse";
